/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/flag/custom-elements';

import { defineCustomElement as defineOsdsFlag } from '@ovhcloud/ods-stencil/components/flag/custom-elements/osds-flag.js';


export const OsdsFlag = /*@__PURE__*/ defineContainer<JSX.OsdsFlag>('osds-flag', defineOsdsFlag, [
  'assetPath',
  'iso',
  'lazy',
  'src'
]);

